import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { usePropertyValue } from './usePropertyValue';
import { urlValidationCache } from '../../cache';
export const useValidateUrl = (options = {
  skip: false
}) => {
  const propertyValue = usePropertyValue();
  const httpClient = useHttpClient();
  const getValidateUrl = useCallback(() => {
    return urlValidationCache.get(propertyValue || '', httpClient);
  }, [httpClient, propertyValue]);
  return useAsyncFunction(getValidateUrl, options);
};